var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-cps-payment',{ref:"table",staticClass:"pt-cps-payment__withData",attrs:{"pageSize":_vm.pageSize,"exportLoading":_vm.exportLoading,"isValidateCompany":_vm.isValidateCompany,"companyList":_vm.companyList},on:{"exportCPS":_vm.exportCPS}})}
var staticRenderFns = []

export { render, staticRenderFns }